import React from "react";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";

const LoadingPanel = () => {
  return (
    <div className="container-fluid position-relative p-0">

      <div className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">Loading</h1>
          </div>
        </div>
      </div>

      {/* Loading Spinner Section */}
      <div className="fixed-top-offset">
        <div className="loading-page">
          <div className="spinner"></div>
          <h2>Loading... Please Wait....</h2>
        </div>
      </div>


    </div>
  );
};

export default LoadingPanel;
